// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1isN5","left":"StickyBox_left__dJBNB","right":"StickyBox_right__1_npM"};